module.exports = __webpack_public_path__ + "img/article_10_2.b3ebba49.png";